import { render } from "./GamePickerPage.vue?vue&type=template&id=4f91351d&scoped=true"
import script from "./GamePickerPage.vue?vue&type=script&lang=js"
export * from "./GamePickerPage.vue?vue&type=script&lang=js"

import "./GamePickerPage.vue?vue&type=style&index=0&id=4f91351d&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f91351d"]])

export default __exports__